<template lang="pug">
div
  app-display(
    v-if="!isRR  && destinacaoUsoImovel.destinacaoImovelChecked"
    :label="labelDestinacaoUsoImovel.destinacaoUsoImovel",
    :content="destinacaoUsoImovel.destinacaoImovelChecked"
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouDestinacaoImovelCheckeds ? 'text': '' "
  )

  app-display(
    v-if="this.finalidades",
    :label="labelDestinacaoUsoImovel.destinacaoUsoImovel",
    :content="this.finalidades"
    :class = "compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouDestinacaoImovel ? 'text': '' "
  )
  app-display(
    v-if="!this.isRR"
    label="Possui Reserva Legal?",
    :content="formatPossuiReservaLegal(destinacaoUsoImovel.possuiReservaLegal)",
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouPossuiReservaLegal ? 'text': '' "
  )
  app-display(
    label="Área:",
    :content="destinacaoUsoImovel.areaReservaLegal && destinacaoUsoImovel.areaReservaLegal != 0 ? formatterDecimal(destinacaoUsoImovel.areaReservaLegal, 4) + ' hectare(s)' : 'Não informado'",
    v-if="hasReservaLegal()"
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouAreaReservaLegal ? 'text': '' "
  )
  app-display(
    label="Percentual utilizado:",
    :content="destinacaoUsoImovel.percentualAreaReservalegal && destinacaoUsoImovel.percentualAreaReservalegal != 0 ? formatPercentualAreaReservaLegal(destinacaoUsoImovel.percentualAreaReservalegal) : 'Não informado'",
    v-if="hasReservaLegal()"
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouPercentualAreaReservaLegal ? 'text': '' "
  )
  app-display(
    label="Total da área em uso:",
    :content="destinacaoUsoImovel.totalAreaEmUso",
    v-if="destinacaoUsoImovel.totalAreaEmUso"
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouTotalAreaEmUso ? 'text': '' "
  )

  app-display(
    label="Tipo de reserva:",
    :content="formatTipoReservaLegal(destinacaoUsoImovel.tipoReservaLegal)",
    v-if="destinacaoUsoImovel.tipoReservaLegal"
  )

  app-divider(label="Informações de Produção ", v-if="isOnerosoGroup && destinacaoUsoImovel.produtividade != null && destinacaoUsoImovel.produtividade.tipo != null && destinacaoUsoImovel.produtividade.tipo !== ''")
  el-row.margin-top(v-if="isOnerosoGroup && destinacaoUsoImovel.produtividade != null && destinacaoUsoImovel.produtividade.tipo != null && destinacaoUsoImovel.produtividade.tipo !== ''")
    el-col(:span="12")
      app-display(
        label="Possui comprovante de produtividade?",
        :content="destinacaoUsoImovel.produtividade.possuiComprovante ? 'Sim' : 'Não'",
        v-if="destinacaoUsoImovel.produtividade.possuiComprovante != null && destinacaoUsoImovel.produtividade.possuiComprovante != ''"
      )
    div(v-if="destinacaoUsoImovel.produtividade.possuiComprovante || destinacaoUsoImovel.produtividade.tipo != ''")
      el-col(:span="12")
        app-display(
          label="Tipo de comprovante:",
          :content="formatTipoComprovante(destinacaoUsoImovel.produtividade.tipo)",
          v-if="destinacaoUsoImovel.produtividade.tipo != null"
          :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouProdutividade && compararDestinacaoUsoImovel.mudouProdutividade.mudouTipo ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          label="Número do DAP:",
          :content="destinacaoUsoImovel.produtividade.dap",
          v-if="destinacaoUsoImovel.produtividade.dap && destinacaoUsoImovel.produtividade.tipo == 'DAP'"
          :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouProdutividade && compararDestinacaoUsoImovel.mudouProdutividade.mudouNumeroDAP ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          label="Número do DRP:",
          :content="destinacaoUsoImovel.produtividade.drp",
          v-if="destinacaoUsoImovel.produtividade.drp && destinacaoUsoImovel.produtividade.tipo == 'DRP'"
          :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouProdutividade && compararDestinacaoUsoImovel.mudouProdutividade.mudouNumeroDRP ? 'text': '' "
        )
      el-col(:span="24")
        listagem-documentos(
          v-if="destinacaoUsoImovel.produtividade.documentos && destinacaoUsoImovel.produtividade.documentos.length > 0"
          :documentos="destinacaoUsoImovel.produtividade.documentos",
          :protocoloCadastroOriginal="protocoloCadastroOriginal"
          ownerDocumento="DESTINACAO_USO_IMOVEL_PRODUTIVIDADE",
          :compararDocumentos="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouProdutividade && compararDestinacaoUsoImovel.mudouProdutividade.mudouDocumentosDestinacaoUsoImovel ? 'text': '' "
          :versaoCadastro="versaoCadastro"
        )

  app-divider(label="Atividades", v-if="showListagem")
  app-collapse-child(
    title="Culturas permanentes",
    name="culturasPermanentes",
    v-if="destinacaoUsoImovel.culturasPermanentes && destinacaoUsoImovel.culturasPermanentes.length > 0"
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaPermanente ? 'text-collapse': '' "
  )
    el-table(
      :data="destinacaoUsoImovel.culturasPermanentes",
    )
      template(slot="empty")
        | Nenhuma cultura permanente cadastrada.
      el-table-column(
        prop="descTipo",
        label="Tipo",
        :formatter="setTipoAtividadeProducao"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaPermanente && compararDestinacaoUsoImovel.mudouCulturaPermanente.mudouTipo ? 'text': '' "
      )
      el-table-column(
        prop="area",
        label="Área",
        :formatter="formatAreaHectare"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaPermanente && compararDestinacaoUsoImovel.mudouCulturaPermanente.mudouArea ? 'text': '' "
      )
      el-table-column(
        v-if="produtividade"
        prop="produtividade",
        label="Produtividade",
        width="180",
        :formatter="formatProdutividade"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaPermanente && compararDestinacaoUsoImovel.mudouCulturaPermanente.mudouProdutividade ? 'text': '' "
      )

  app-collapse-child(
    title="Culturas temporárias",
    name="culturasTemporarias",
    v-if="destinacaoUsoImovel.culturasTemporarias && destinacaoUsoImovel.culturasTemporarias.length > 0"
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaTemporaria ? 'text-collapse': '' "
  )
    el-table(
      :data="destinacaoUsoImovel.culturasTemporarias",
    )
      template(slot="empty")
        | Nenhuma cultura temporária cadastrada.
      el-table-column(
        prop="tipo",
        label="Tipo",
        :formatter="setTipoAtividadeProducao"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaTemporaria && compararDestinacaoUsoImovel.mudouCulturaTemporaria.mudouTipo ? 'text': '' "
      )
      el-table-column(
        prop="area",
        label="Área",
        :formatter="formatAreaHectare"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaTemporaria && compararDestinacaoUsoImovel.mudouCulturaTemporaria.mudouArea ? 'text': '' "
      )
      el-table-column(
        v-if="produtividade"
        prop="produtividade",
        label="Produtividade",
        width="200",
        :formatter="formatProdutividade"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouCulturaTemporaria && compararDestinacaoUsoImovel.mudouCulturaTemporaria.mudouProdutividade ? 'text': '' "
      )
  app-collapse-child(title="Semoventes", v-if="destinacaoUsoImovel.semoventes && destinacaoUsoImovel.semoventes.length > 0" :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouSemovente ? 'text-collapse': '' ")
    el-table(
      :data="destinacaoUsoImovel.semoventes",
    )
      template(slot="empty")
        | Nenhum semovente cadastrado.
      el-table-column(
        prop="tipo",
        label="Tipo",
        :formatter="setTipoAtividadeProducao"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouSemovente && compararDestinacaoUsoImovel.mudouSemovente.mudouTipo ? 'text': '' "
      )
      el-table-column(
        v-if="destinacaoUsoImovel.semoventes[0].area !== 0 && destinacaoUsoImovel.semoventes[0].area !== '' && destinacaoUsoImovel.semoventes[0].area !== null"
        prop="area",
        label="Área",
        :formatter="formatAreaHectare"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouSemovente && compararDestinacaoUsoImovel.mudouSemovente.mudouArea ? 'text': '' "
      )
      el-table-column(
        prop="numeroCabecas",
        label="Número de cabeças"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouSemovente && compararDestinacaoUsoImovel.mudouSemovente.mudouNumeroCabecas ? 'text': '' "
      )
      el-table-column(
        v-if="produtividade"
        prop="produtividade",
        label="Produtividade (cabeças/hectare)",
        width="300"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouSemovente && compararDestinacaoUsoImovel.mudouSemovente.mudouProdutividade ? 'text': '' "
      )
  app-collapse-child(
    title="Outras atividades",
    name="outrasAtividades",
    v-if="destinacaoUsoImovel.outrasAtividades && destinacaoUsoImovel.outrasAtividades.length > 0"
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouOutrasAtividade ? 'text-collapse': '' "
  )
    el-table(
      :data="destinacaoUsoImovel.outrasAtividades",
    )
      template(slot="empty")
        | Nenhuma outra atividade cadastrada.
      el-table-column(
        prop="tipo",
        label="Tipo",
        :formatter="getAtividadesOutros"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouOutrasAtividade && compararDestinacaoUsoImovel.mudouOutrasAtividade.mudouTipo ? 'text': '' "
      )
      el-table-column(
        prop="area",
        label="Área",
        :formatter="formatAreaHectare"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouOutrasAtividade && compararDestinacaoUsoImovel.mudouOutrasAtividade.mudouArea ? 'text': '' "
      )
      el-table-column(
        prop="observacoes",
        label="Observações"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouOutrasAtividade && compararDestinacaoUsoImovel.mudouOutrasAtividade.mudouObservacoes ? 'text': '' "
      )

  app-collapse-child(
    title="Edificações",
    name="edificacoes",
    v-if="destinacaoUsoImovel.edificacoes && destinacaoUsoImovel.edificacoes.length > 0"
    :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouEdificacoes ? 'text-collapse': '' "
  )
    el-table(
      :data="destinacaoUsoImovel.edificacoes",
    )
      template(slot="empty")
        | Nenhuma edificação cadastrada.
      el-table-column(
        prop="tipo",
        label="Tipo",
        :formatter="setTipoAtividadeProducao"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouEdificacoes && compararDestinacaoUsoImovel.mudouEdificacoes.mudouTipo ? 'text': '' "
      )
      el-table-column(
        prop="area",
        label="Área",
        :formatter="formatUnidadeArea"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouEdificacoes && compararDestinacaoUsoImovel.mudouEdificacoes.mudouArea ? 'text': '' "
      )
      el-table-column(
        v-if="destinacaoUsoImovel.edificacoes[0].funcao!=='' && destinacaoUsoImovel.edificacoes[0].funcao!==null"
        prop="funcao",
        label="Função"
        :class="compararDestinacaoUsoImovel && compararDestinacaoUsoImovel.mudouEdificacoes && compararDestinacaoUsoImovel.mudouEdificacoes.mudouFuncao ? 'text': '' "
      )
</template>

<script>
import AppDisplay from '../AppDisplay'
import utils from '@/utils/utils'
import AppCollapseChild from '@/components/AppCollapseChild'
import AppCollapse from '@/components/AppCollapse'
import AppDivider from '@/components/AppDivider'
import ListagemDocumentos from './ListagemDocumentos'
import compararReticacoesDefault from '../../utils/pa/compararReticacoesDefault'
const { labelVisualizacaoProcesso } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppDisplay,
    AppCollapseChild,
    AppCollapse,
    AppDivider,
    ListagemDocumentos
  },

  props: {
    destinacaoUsoImovel: {
      type: Object,
      required: true
    },
    isOnerosoGroup: {
      type: Boolean,
      default: false,
      required: false
    },
    protocoloCadastroOriginal: {
      type: String,
      required: false
    },
    compararDestinacaoUsoImovel: {
      type: Object,
      default: compararReticacoesDefault.mudouDestinacaoUsoImovelDTODefault
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    }
  },

  mounted () {
    this.isRR = process.env.ESTADO.toLowerCase() === 'rr'
    this.setFinalidades()
  },

  data () {
    return {
      destinacaoUsoImovelCollapse: ['0'],
      finalidades: '',
      labelDestinacaoUsoImovel: labelVisualizacaoProcesso.etapaDestinacaoUsoImovel,
      isRR: false,
      produtividade: null
    }
  },

  computed: {
    showListagem () {
      if ((this.destinacaoUsoImovel.semoventes && this.destinacaoUsoImovel.semoventes.length > 0) ||
          (this.destinacaoUsoImovel.culturasPermanentes && this.destinacaoUsoImovel.culturasPermanentes.length > 0) ||
          (this.destinacaoUsoImovel.culturasTemporarias && this.destinacaoUsoImovel.culturasTemporarias.length > 0) ||
          (this.destinacaoUsoImovel.manejosFlorestais && this.destinacaoUsoImovel.manejosFlorestais.length > 0) ||
          (this.destinacaoUsoImovel.outrasAtividades && this.destinacaoUsoImovel.outrasAtividades.length > 0) ||
          (this.destinacaoUsoImovel.edificacoes && this.destinacaoUsoImovel.edificacoes.length > 0)) {
        return true
      }
      return false
    }
  },

  created () {
    if (this.destinacaoUsoImovel.culturasPermanentes && this.destinacaoUsoImovel.culturasPermanentes.length > 0) {
      this.destinacaoUsoImovelCollapse = 'culturasPermanentes'
    }
    if (this.destinacaoUsoImovel.culturasTemporarias && this.destinacaoUsoImovel.culturasTemporarias.length > 0) {
      this.destinacaoUsoImovelCollapse = 'culturasTemporarias'
    }
    if (this.destinacaoUsoImovel.semoventes && this.destinacaoUsoImovel.semoventes.length > 0) {
      this.destinacaoUsoImovelCollapse = 'semoventes'
    }
    if (this.destinacaoUsoImovel.manejosFlorestais && this.destinacaoUsoImovel.manejosFlorestais.length > 0) {
      this.destinacaoUsoImovelCollapse = 'manejosFlorestais'
    }
    if (this.destinacaoUsoImovel.outrasAtividades && this.destinacaoUsoImovel.outrasAtividades.length > 0) {
      this.destinacaoUsoImovelCollapse = 'outrasAtividades'
    }
    if (this.destinacaoUsoImovel.edificacoes && this.destinacaoUsoImovel.edificacoes.length > 0) {
      this.destinacaoUsoImovelCollapse = 'edificacoes'
    }
    this.setTotalAreaEmUso()
  },

  methods: {
    setTipoAtividadeProducao (prop) {
      if (prop?.descricao && prop.descricao !== '') {
        return prop.tipo === 'OUTROS'
          ? 'OUTROS - ' + prop.descricao : prop.descricao
      } else if (prop?.descTipo && prop.descTipo !== '') {
        return prop.tipo === 'OUTROS'
          ? 'OUTROS - ' + prop.descTipo : prop.descTipo
      } else {
        return prop?.tipoAtividadeProducao?.descricao || prop.tipo
      }
    },

    getAtividadesOutros (atividade) {
      if (atividade.tipo === null) return '-'
      if (atividade.tipo === 'APICULTURA') return 'Apicultura'
      if (atividade.tipo === 'AVICULTURA') return 'Avicultura'
      if (atividade.tipo === 'CUNICULTURA') return 'Cunicultura'
      if (atividade.tipo === 'FLORICULTURA') return 'Floricultura'
      if (atividade.tipo === 'FRUTICULTURA') return 'Fruticultura'
      if (atividade.tipo === 'OLERICULTURA') return 'Olericultura'
      if (atividade.tipo === 'BOVINOCULTURA') return 'Bovinocultura'
      return atividade.tipo
    },

    setTotalAreaEmUso () {
      let areaEmUso = 0.0

      areaEmUso += this.destinacaoUsoImovel.semoventes && this.destinacaoUsoImovel.semoventes.length > 0 ? this.destinacaoUsoImovel.semoventes
        .map(semovente => semovente.area).reduce((area, semovente) => area + semovente) : 0

      areaEmUso += this.destinacaoUsoImovel.outrasAtividades && this.destinacaoUsoImovel.outrasAtividades.length > 0 ? this.destinacaoUsoImovel.outrasAtividades
        .map(outraAtividade => outraAtividade.area).reduce((area, outraAtividade) => area + outraAtividade) : 0

      areaEmUso += this.destinacaoUsoImovel.culturasTemporarias && this.destinacaoUsoImovel.culturasTemporarias.length > 0 ? this.destinacaoUsoImovel.culturasTemporarias
        .map(culturaTemporaria => culturaTemporaria.area).reduce((area, culturaTemporaria) => area + culturaTemporaria) : 0

      areaEmUso += this.destinacaoUsoImovel.culturasPermanentes && this.destinacaoUsoImovel.culturasPermanentes.length > 0 ? this.destinacaoUsoImovel.culturasPermanentes
        .map(culturaPermanente => culturaPermanente.area).reduce((area, culturaPermanente) => area + culturaPermanente) : 0

      this.destinacaoUsoImovel.totalAreaEmUso = areaEmUso > 0 ? areaEmUso + ' hectare(s)' : undefined
    },

    formatterDecimal (value, precision) {
      return utils.format(value, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision })
    },

    formatPossuiReservaLegal (resposta) {
      if (resposta === 'SIM') { return 'Sim' }
      if (resposta === 'NAO') { return 'Não' }
      if (resposta === 'NAO_SABE') { return 'Não sabe responder' }
    },

    formatPercentualAreaReservaLegal (area) {
      area = this.formatterDecimal(area, 2)
      return area + ' %'
    },

    formatProdutividade (row) {
      if (row.descUnidadeProducao !== null) {
        return row.produtividade + ' ' + (row.descUnidadeProducao || row.tipoUnidadeProducao?.descricao)
      }
      const produtividade = this.formatterDecimal(row.produtividade, 4)
      return produtividade
    },

    hasAtividades () {
      return (this.destinacaoUsoImovel.culturasPermanentes && this.destinacaoUsoImovel.culturasPermanentes.length > 0) ||
        (this.destinacaoUsoImovel.semoventes && this.destinacaoUsoImovel.semoventes.length > 0) ||
        (this.destinacaoUsoImovel.culturasTemporarias && this.destinacaoUsoImovel.culturasTemporarias.length > 0)
    },

    hasReservaLegal () {
      return this.destinacaoUsoImovel.possuiReservaLegal === 'SIM' && this.isMaranhao
    },

    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },

    formatAreaHectare (row) {
      return this.formatterDecimal(row.area, 4) + ' hectare(s)'
    },

    // Medida paliativa para listar finalidades
    setFinalidades () {
      if (this.destinacaoUsoImovel.agricultura) {
        this.finalidades = this.finalidades + '- Agricultura '
      }
      if (this.destinacaoUsoImovel.moradia) {
        this.finalidades = this.finalidades + '- Moradia '
      }
      if (this.destinacaoUsoImovel.pecuaria) {
        this.finalidades = this.finalidades + '- Pecuária '
      }
      if (this.destinacaoUsoImovel.silvicultura) {
        this.finalidades = this.finalidades + '- Silvicultura '
      }
      if (this.destinacaoUsoImovel.outros) {
        this.finalidades = this.finalidades + '- Outros '
      }
      if (this.destinacaoUsoImovel.educacao) {
        this.finalidades = this.finalidades + '- Educação '
      }
      if (this.destinacaoUsoImovel.pesquisa) {
        this.finalidades = this.finalidades + '- Pesquisa '
      }
      if (this.destinacaoUsoImovel.industria) {
        this.finalidades = this.finalidades + '- Indústria '
      }
      if (this.destinacaoUsoImovel.mineracao) {
        this.finalidades = this.finalidades + '- Mineração '
      }
      if (this.destinacaoUsoImovel.recreacao) {
        this.finalidades = this.finalidades + '- Recreação '
      }
      if (this.destinacaoUsoImovel.manejoFlorestal) {
        this.finalidades = this.finalidades + '- Manejo florestal '
      }
      if (this.destinacaoUsoImovel.assitencialHospitalar) {
        this.finalidades = this.finalidades + '- Assitencial/Hospitalar '
      }
      if (this.destinacaoUsoImovel.servidaoAmbiental) {
        this.finalidades = this.finalidades + '- Servidão ambiental '
      }
      if (this.destinacaoUsoImovel.sistemasAgroflorestais) {
        this.finalidades = this.finalidades + '- Sistemas agroflorestais '
      }
      this.finalidades = this.finalidades.substring(1, this.finalidades.length)
    },

    formatUnidadeArea (row) {
      return this.formatterDecimal(row.area, 4) + ' ' + (row.descUnidadeArea || row.tipoUnidadeArea?.descricao)
    },

    formatTipoReservaLegal (tipo) {
      switch (tipo) {
        case 'UNIDADE_PROTECAO_AMBIENTAL':
          return 'Unidade de Proteção Ambiental'
        case 'UNIDADE_PROTECAO_INTEGRAL':
          return 'Unidade de Proteção Integral'
        case 'RESERVA_EXTRATIVISTA':
          return 'Reserva Extrativista'
        case 'RESERVA_AMBIENTAL':
          return 'Reserva Ambiental'
        case 'RESERVA_PARTICULAR':
          return 'Reserva Particular do Patrimônio Natural'
        default:
          return ''
      }
    },

    formatTipoComprovante (tipo) {
      switch (tipo) {
        case 'DAP':
          return 'Declaração de Aptidão ao PRONAF – DAP'
        case 'DRP':
          return 'Diagnóstico Rural Participativo – DRP'
        case 'OUTROS':
          return 'Outros'
        default:
          return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-top {
  margin-top: 10px;
}
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesDestinacaoUsoImovel.vue